<template>
	<div :class="`flex flex-col items-stretch text-sm ${full ? 'grow' : ''}`">
		<div class="flex items-end gap-3">
			<div class="grow flex flex-col">
				<p class="text-gray-500 font-semibold text-sm"><slot name="label"/></p>
				<p v-if="description" class="text-gray-400 dark:text-gray-600 text-xs">{{ description }}</p>
			</div>
			<p v-if="required" class="text-red-600 dark:text-red-400 whitespace-nowrap">* {{ trans('general.required') }}</p>
		</div>
		<div class="w-full flex justify-stretch text-gray-700 dark:text-gray-300">
			<slot/>
		</div>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'

defineProps<{
	full?:boolean,
	required?:boolean,
	description?:string,
}>()
</script>